/**
 * Validation.js
 * Created by calhosh on 7/9/2020.
 */

import React, {useContext, useEffect, useState, useCallback} from 'react';
import {getValidationCountForIds, GetGuidedWorkFlowValidationCount} from './ValidationUtility';
import {documentTypes, entities, ValidationWithoutApprovalsDocumentTypes} from '../../../../util/uiconstants';
import {useSelector} from 'react-redux';
import ValidationControl from './ValidationControl';
import {loadStorage} from '../../localStorage';
import {DocumentTypeIdContext} from '../../../Main/Forms/CanvasFormContainer';
import Utility from '../../../../util/utilityfunctions';
import {getTaskDocumentByDocumentId, getSectionById} from '../../../../selectors/Ares/selectors';
import {getValidationsForDocumentId} from '../../../../selectors/Forms/canvasFormSelectors';

export default function Validation(props) {
	const {
		documentId,
		headerId,
		sectionId,
		bodyId,
		displayFor,
		clearComments,
		setHaveValidationsCount,
		setShowCreateDocumentModal,
		bodyTypeId
	} = props;

	const [headerIncompleteResponseCount, setHeaderIncompleteResponseCount] = useState(0),
		[headerUnresolvedCommentCount, setHeaderUnresolvedCommentCount] = useState(0),
		[headerGuidedWorkFlowValidations, setHeaderGuidedWorkFlowValidations] = useState([]),
		[sectionIncompleteResponseCount, setSectionIncompleteResponseCount] = useState(0),
		[sectionUnresolvedCommentsCount, setSectionUnresolvedCommentsCount] = useState(0),
		[sectionGuidedWorkFlowValidations, setSectionGuidedWorkFlowValidations] = useState([]),
		[bodyIncompleteResponseCount, setBodyIncompleteResponseCount] = useState(0),
		[bodyUnresolvedCommentsCount, setBodyUnresolvedCommentsCount] = useState(0),
		[bodyGuidedWorkFlowValidations, setBodyGuidedWorkFlowValidations] = useState([]);


	const documentTypeId = useContext(DocumentTypeIdContext);

	let validations = useSelector((store) => getValidationsForDocumentId(store, documentId));
	const document = useSelector((storeState) => getTaskDocumentByDocumentId(storeState, documentId));
	const sectionBodyData = useSelector((state) => state.formBodyData);
	const sectionDetails = useSelector((state) => getSectionById(state, sectionId));

	const validationsFilter = sectionDetails?.isSummary ? loadStorage('validationsFilter') : undefined;

	const displayValidationControl =
		ValidationWithoutApprovalsDocumentTypes.indexOf(documentTypeId) > -1 ||
		document?.approvals?.length > 0;

	const showBodyValidations =
		ValidationWithoutApprovalsDocumentTypes.indexOf(documentTypeId) > -1
			? true
			: document?.approvals?.length > 0 || false;

	const updateHeaderValidations = () => {
		const counts = getValidationCountForIds(
			headerId,
			undefined,
			undefined,
			validations,
			validationsFilter,
			documentTypeId
		);

		setHeaderIncompleteResponseCount(counts.incompleteCount);
		setHeaderUnresolvedCommentCount(counts.unresolvedCount);

		if (Utility.isDocumentTypeFit(documentTypeId) && documentTypeId !== documentTypes.INDEPENDENCEFORMINDIVIDUAL) {
			setHeaderGuidedWorkFlowValidations(
				GetGuidedWorkFlowValidationCount(counts.guidedWorkFlowValidations) > 0 ? counts.guidedWorkFlowValidations : []
			);
		}
	};

	const updateSectionValidations = () => {
		const sectionBodyTypeData = sectionBodyData
			?.find((x) => x.sectionId === sectionId)
			?.bodies.map((x) => {
				return {id: x?.id, bodyTypeId: x?.bodyTypeId};
			});

		const counts = getValidationCountForIds(
			headerId,
			sectionId,
			undefined,
			validations,
			validationsFilter,
			documentTypeId,
			false,
			sectionBodyTypeData
		);

		const guidedWorkflowValidationResults =
			GetGuidedWorkFlowValidationCount(counts.guidedWorkFlowValidations) > 0 ? counts.guidedWorkFlowValidations : [];

		setSectionIncompleteResponseCount(counts.incompleteCount);
		setSectionUnresolvedCommentsCount(counts.unresolvedCount);

		if (Utility.isDocumentTypeFit(documentTypeId) && documentTypeId !== documentTypes.INDEPENDENCEFORMINDIVIDUAL) {
			setSectionGuidedWorkFlowValidations(
				GetGuidedWorkFlowValidationCount(counts.guidedWorkFlowValidations) > 0 ? counts.guidedWorkFlowValidations : []
			);
		}

		setHaveValidationsCount &&
			setHaveValidationsCount(
				displayValidationControl &&
					(counts.incompleteCount > 0 ||
						counts.unresolvedCount > 0 ||
						(Utility.isDocumentTypeFit(documentTypeId) && guidedWorkflowValidationResults.length > 0))
			);
	};

	const updateBodyValidations = () => {
		const counts = getValidationCountForIds(
			headerId,
			sectionId,
			bodyId,
			validations,
			validationsFilter,
			documentTypeId
		);

		const guidedWorkflowValidationResults =
			GetGuidedWorkFlowValidationCount(counts.guidedWorkFlowValidations) > 0 ? counts.guidedWorkFlowValidations : [];

		setBodyIncompleteResponseCount(counts.incompleteCount);
		setBodyUnresolvedCommentsCount(counts.unresolvedCount);

		if (Utility.isDocumentTypeFit(documentTypeId) && documentTypeId !== documentTypes.INDEPENDENCEFORMINDIVIDUAL) {
			setBodyGuidedWorkFlowValidations(guidedWorkflowValidationResults);
		}

		setHaveValidationsCount(
			displayValidationControl &&
				(counts.incompleteCount > 0 ||
					counts.unresolvedCount > 0 ||
					(Utility.isDocumentTypeFit(documentTypeId) && guidedWorkflowValidationResults.length > 0))
		);
	};

	const clearCommentValidations = useCallback(
		(entityId, entityUid) => {
			clearComments(entityId, entityUid);
		},
		[clearComments]
	);

	useEffect(() => {
		switch (displayFor) {
			case 'header':
				updateHeaderValidations();
				break;
			case 'section':
				updateSectionValidations();
				break;
			case 'body':
				updateBodyValidations();
				break;
		}
	}, [headerId, sectionId, bodyId, displayFor, validations]);

	const headerValidationCount =
		headerIncompleteResponseCount + headerUnresolvedCommentCount + headerGuidedWorkFlowValidations.length;

	const sectionValidationCount =
		sectionIncompleteResponseCount + sectionUnresolvedCommentsCount + sectionGuidedWorkFlowValidations.length;

	const bodyValidationCount =
		bodyIncompleteResponseCount + bodyUnresolvedCommentsCount + bodyGuidedWorkFlowValidations.length;

	return (
		<>
			{displayValidationControl && (
				<>
					{displayFor === 'header' && headerValidationCount > 0 && (
						<section className="sectionBody-validation">
							<ValidationControl
								documentId={documentId}
								incompleteResponseCount={headerIncompleteResponseCount}
								unresolvedCommentCount={headerUnresolvedCommentCount}
								entityId={entities.FormHeader}
								entityUId={headerId}
								clearComments={clearCommentValidations}
								guidedWorkFlowValidationDetails={headerGuidedWorkFlowValidations || []}
							/>
						</section>
					)}
					{displayFor === 'section' && sectionValidationCount > 0 && (
						<section className="sectionBody-validation">
							<ValidationControl
								documentId={documentId}
								incompleteResponseCount={sectionIncompleteResponseCount}
								unresolvedCommentCount={sectionUnresolvedCommentsCount}
								entityId={entities.FormSection}
								entityUId={sectionId}
								clearComments={clearCommentValidations}
								guidedWorkFlowValidationDetails={sectionGuidedWorkFlowValidations || []}
								displayFor={displayFor}
								bodyTypeId={bodyTypeId}
							/>
						</section>
					)}
					{displayFor === 'body' && showBodyValidations && bodyValidationCount > 0 && (
						<section className="sectionBody-validation">
							<ValidationControl
								documentId={documentId}
								incompleteResponseCount={bodyIncompleteResponseCount}
								unresolvedCommentCount={bodyUnresolvedCommentsCount}
								entityId={entities.FormBody}
								entityUId={bodyId}
								clearComments={clearCommentValidations}
								guidedWorkFlowValidationDetails={bodyGuidedWorkFlowValidations || []}
								displayFor={displayFor}
								setShowCreateDocumentModal={setShowCreateDocumentModal}
								bodyTypeId={bodyTypeId}
							/>
						</section>
					)}
				</>
			)}
		</>
	);
}
